<template>
  <div class="">
    <div v-if="!currentVideo">
      <!--      <h2 class="font-serif text-2xl">Videos</h2>-->
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
        <div v-for="video in videos" :key="video.title" class="rounded flex flex-col cursor-pointer transition-all gap-2 group" role="button" @click="setCurrentVideo(video)">
          <img :src="video.poster" class="rounded shadow aspect-[16/9]" :alt="video.title" />
          <div class="flex justify-between">
            <div class="flex gap-1 text-sm">
              <u-icon name="i-ri-play-circle-fill" class="w-5 mt-1" />
              <span class="text-heroblue font-semibold group-hover:underline">{{video.title}}</span>
            </div>

            <span class="text-gray-400">{{formatDuration(video.length)}}</span>
          </div>
        </div>
      </div>

      <!--      <h2 class="font-serif text-2xl">Guides</h2>
      <div class="grid grid-cols-4 gap-5">
        <div v-for="guide in guides" :key="guide.title" class="flex gap-2 border border-gray-400 rounded p-3 hover:shadow bg-shell-100 hover:bg-shell-200 cursor-pointer" @click="guide.action" type="button">
          <u-icon :name="guide.icon" class="text-2xl text-charcoal-300" />
          <span class="font-semibold">{{guide.title}}</span>
        </div>
      </div>-->
    </div>

    <template v-else>

      <h2 class="text-2xl font-semibold">{{currentVideo.title}}</h2>
      <div class="flex flex-col gap-2">
        <div class="w-full overflow-hidden relative border-4 rounded border-gray-300">
          <client-only>
            <core-media-player
              no-cross-origin
              :src="currentVideo.url"
              :poster-src="currentVideo.poster"
              ref="mediaPlayerComp"
            />
          </client-only>
        </div>
        <div>
          <u-button @click="setCurrentVideo(null)" icon="i-ri-arrow-left-s-line" variant="link" :padded="false" size="xl">Back</u-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>

  const props = defineProps({
    toVideo: Object,
  });

  const {videos} = useOnboardingVideos();
  const currentVideo = ref(props.toVideo);

  const mediaPlayerComp = ref();

  function setCurrentVideo(video) {
    currentVideo.value = video;
  }

  onMounted(async () => {
    watch(currentVideo, async (newVal) => {
      if (newVal) {
        await nextTick();

        mediaPlayerComp.value.autoPlay();
      }
    },
    {
      immediate: true
    });
  });

</script>
